import { Colors } from "@/common/constants";
import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	green: {
		backgroundColor: Colors.ButtonGreenBackground,
		borderBlockColor: Colors.ButtonGreenBackground,
		":disabled": {
			backgroundColor: tokens.colorNeutralForeground3,
			"&:hover": {
				backgroundColor: tokens.colorNeutralForeground3,
				":active": {
					backgroundColor: tokens.colorNeutralForeground3,
				},
			},
			":active": {
				backgroundColor: tokens.colorNeutralForeground3,
			},
		},
		":hover": {
			backgroundColor: Colors.ButtonGreenBackground,
			borderBlockColor: Colors.ButtonGreenBackground,
			":active": {
				backgroundColor: Colors.ButtonGreenBackground,
				borderBlockColor: Colors.ButtonGreenBackground,
			},
		},
	},
	white: {
		backgroundColor: tokens.colorNeutralForegroundStaticInverted,
	},
	tooltipContent: {
		zIndex: 3,
	},
});
